import { CellDataType } from "components/adhoc/gistreestructuretable.component";
import { HierarchyItemType } from "types/generic";

type MakeGisTreeStructureTableFunctionsParams = {
    gisHierarchySelected: HierarchyItemType[];
    setGisHierarchySelected: React.Dispatch<
        React.SetStateAction<HierarchyItemType[]>
    >;
    dataHierarchy: HierarchyItemType[];
};

const unselectChildElements = (
    hierarchySelectedAux: HierarchyItemType[],
    parentNode: HierarchyItemType
) => {
    const childNodeExists = hierarchySelectedAux.filter(
        (e) => e.parent === parentNode.id
    );

    if (childNodeExists.length) {
        hierarchySelectedAux = hierarchySelectedAux.filter(
            (e) => e.parent !== parentNode.id
        );
        childNodeExists.forEach((e) => {
            hierarchySelectedAux = unselectChildElements(
                hierarchySelectedAux,
                e
            );
        });
    }

    return hierarchySelectedAux;
};

const selectAllChildElements = (
    allHierarchyData: HierarchyItemType[],
    hierarchySelectedAux: HierarchyItemType[],
    parentNode: HierarchyItemType
) => {
    const childNodeExists = allHierarchyData.filter(
        (e) => e.parent === parentNode.id
    );

    if (childNodeExists.length) {
        allHierarchyData.forEach((e) => {
            if (e.parent === parentNode.id) {
                const elementAlreadyOnList = hierarchySelectedAux.some(
                    (hierarchy) => hierarchy.id === e.id
                );

                if (elementAlreadyOnList) return;

                hierarchySelectedAux.push(e);
            }
        });

        childNodeExists.forEach((e) => {
            hierarchySelectedAux = selectAllChildElements(
                allHierarchyData,
                hierarchySelectedAux,
                e
            );
        });
    }

    return hierarchySelectedAux;
};

const unselectParentElements = (
    hierarchySelectedAux: HierarchyItemType[],
    childNode: HierarchyItemType
) => {
    const parentNode = hierarchySelectedAux.filter(
        (e) => e.id === childNode.parent
    );

    if (parentNode.length) {
        hierarchySelectedAux = hierarchySelectedAux.filter(
            (e) => e.id !== childNode.parent
        );

        hierarchySelectedAux = unselectParentElements(
            hierarchySelectedAux,
            parentNode[0]
        );
    }

    return hierarchySelectedAux;
};

export const makeGisTreeStructureTableFunctions = ({
    gisHierarchySelected,
    setGisHierarchySelected,
    dataHierarchy,
}: MakeGisTreeStructureTableFunctionsParams) => {
    const handleCheckboxCheck = (cellData: CellDataType) => {
        const targetElement = gisHierarchySelected.findIndex(
            (e: any) => e.id === cellData.data.id
        );

        if (targetElement !== -1) {
            const unselectedNode = gisHierarchySelected.splice(
                targetElement,
                1
            );

            let hierarchySelectedAux = [...gisHierarchySelected];

            hierarchySelectedAux = unselectParentElements(
                hierarchySelectedAux,
                unselectedNode[0]
            )!;

            hierarchySelectedAux = unselectChildElements(
                hierarchySelectedAux,
                unselectedNode[0]
            );

            setGisHierarchySelected(hierarchySelectedAux);
        } else {
            let hierarchySelectedAux = [...gisHierarchySelected];

            hierarchySelectedAux = selectAllChildElements(
                dataHierarchy,
                hierarchySelectedAux,
                cellData.data
            );

            setGisHierarchySelected([cellData.data, ...hierarchySelectedAux]);
        }
    };

    return {
        handleCheckboxCheck,
    };
};
